var site = site || {};

site.direction = site.direction || {};

(function ($) {
  'use strict';

  Drupal.behaviors.bobbisLessonsCarouselV1 = {
    initProductGrids: function ($ele) {
    // Drupal.behaviors.productGrid.attach();
      site.productCarousel.init($('.product-grid__content', $ele));
    },

    attach: function (context, settings) {
      var self = this,
        $module = $('.bobbis-lessons', context),
        isTouch = Modernizr.touch;

      // slick carousel not included
      /*
    if (!$.isFunction($.slick)) {
      return;
    }
    */

      // Support multiple instances of this formatter on a page
      $module.each(function (i) {
        var $me = $(this),
          $carousel = $('.bobbis-lessons__carousel', $me);

        // Create some classes for some unknown reason
        /*
      $('.bobbis-lessons__slide', $carousel).each(function(j) {
        $(this).addClass('bobbis-lessons__slide--' + (j + 1));
      });
      */

        // -----------------------
        // Initialize the carousel
        // -----------------------
        $carousel.slick({
          rtl: site.direction.isRTL,
          infinite: false,
          slide: 'div.bobbis-lessons__slide',
          onInit: function () {
            var $slides = $('.bobbis-lessons__slide', $carousel),
              numSlides = $slides.length;

            // Move the previous/next buttons around in the dom
            // This forces their positioning to be relative to the carousel of items, and
            // doesn't factor in the height of the product grid below.
            $('[type="button"]', $carousel).filter(function () {
              return $(this).attr('class').match(/slick-/g);
            }).detach().appendTo($('.slick-list', $carousel));

            // Act upon the "previous" and "next" buttons on the slides
            $slides.each(function (i) {
              var $slide = $(this),
                $prev = $('.bobbis-lessons__preview--prev', $slide),
                $next = $('.bobbis-lessons__preview--next', $slide);
              var hasPrev = true,
                hasNext = true;
              var $prevSlide = $(),
                $nextSlide = $();

              // Remove the "previous" element on the first slide
              if (i == 0) {
                $prev.remove();
                hasPrev = false;
              } else {
                $prevSlide = $slides.eq(i - 1);
              }

              // Remove the "next" element on the last slide
              if (i == numSlides - 1) {
                $next.remove();
                hasNext = false;
              } else {
                $nextSlide = $slides.eq(i + 1);
              }

              // There's probably a better way to consolidate these 2 conditionals, but this works for now.
              if (hasPrev) {
              // Set the current "previous" layer's title to the previous slide's value
                var prevTitle = $('.bobbis-lessons__headline', $prevSlide).text();

                $('.h8', $prev).html(prevTitle);

                // Set the current "previous" layer's thumbnail image to the previous slide's value
                var prevThumb = $('.bobbis-lessons__content', $prevSlide).data('thumbnail-image');

                if (prevThumb.length > 0) {
                  $('.thumb', $prev).attr('src', prevThumb);
                }
              }

              if (hasNext) {
              // Set the curent "next" layer's title to the next slide's value
                var nextTitle = $('.bobbis-lessons__headline', $slides.eq(i + 1)).text();

                $('.h8', $next).html(nextTitle);

                // Set the current "next" layer's thumbnail image to the next slide's value
                var nextThumb = $('.bobbis-lessons__content', $nextSlide).data('thumbnail-image');

                if (nextThumb.length > 0) {
                  $('.thumb', $next).attr('src', nextThumb);
                }
              }
            });

            // Un-hide the first related products carousel
            var $frp = $('.bobbis-lessons__related_products', $me).first();

            $frp.removeClass('hidden').addClass('active');

            // Initialize the product grids
            self.initProductGrids($frp);
          },

          // Before the slide transition starts
          onBeforeChange: function () {
            var $m = $me,
              $cp = $('.bobbis-lessons__related_products', $m).filter('.active');

            // Hide any active related product carousels
            $cp.slideUp('fast', function () {
              var $t = $(this);

              $t.addClass('hidden').removeClass('active');

            // @TODO: destroy the carousel for memory optimization
            // $t.find('.product-grid__content').unslick();
            });
          },

          // After the slide transition ends
          onAfterChange: function () {
            var $m = $me,
              $c = $carousel,
              cli = $c.slickCurrentSlide(),
              $cp = $('.bobbis-lessons__related_products', $m).eq(cli);

            // Show the related products for this slide
            $cp.slideDown('fast', function () {
              var $t = $(this);

              $t.removeClass('hidden').addClass('active');

              // Initialize the product grids
              self.initProductGrids($t);
            });
          }
        });

        // Display only for non touch devices
        if (!isTouch) {
          var $prev = $('.bobbis-lessons__preview--prev', $carousel);
          var $next = $('.bobbis-lessons__preview--next', $carousel);

          $('.slick-next', $carousel).hoverIntent(function () {
            $next.show().stop().animate({
              'right': 0
            }, 400, 'easeOutQuad');
          }, function () {
            $next.hide().css({
              'right': -295
            });
          });

          $('.slick-prev', $carousel).hoverIntent(function () {
            $prev.show().stop().animate({
              'left': 0
            }, 400, 'easeOutQuad');
          }, function () {
            $prev.hide().css({
              'left': -295
            });
          });
        }

        // This is where things get a little bit tricky, but necessary

        // First, wrap all "related product" blocks inside a wrapper div,
        // then we move it outside of the main container, which has a black bg
        $('.bobbis-lessons__related_products', $me)
          .wrapAll('<div class="bobbis-lessons__related_products--wrapper" />')
          .parent()
          .detach()
          .appendTo($me);

        // Then attach a click event to ...
        $('.js-link--get-the-look', $me).once().click(function (e) {
          e.preventDefault();

          var $ele = $(this);
          var $icon = $('.icon', $ele),
            iIsDn = $icon.hasClass('icon-arrow_down'),
            iAdd = 'icon-arrow_' + (iIsDn ? 'up' : 'down'),
            iRem = 'icon-arrow_' + (iIsDn ? 'down' : 'up');

          // Traverse around to the related products wrapper, the slideToggle it 
          $ele
            .closest('section.bobbis-lessons')
            .children('.bobbis-lessons__related_products--wrapper')
            .slideToggle(400, function () {
              var $wrapper = $(this);
              var $grid = $('.product-grid--quickshop', $wrapper);
              var bp = Unison.fetch.now().name;

              Drupal.behaviors.productGrid.equalHeights($wrapper);

              // Initialize the product grids
              self.initProductGrids($wrapper);
              Drupal.behaviors.quickshop.initGrid($grid, bp);

              // Scroll to 'em
              $(window).scrollTo($wrapper, 800, {
                'offset': -69,
                'axis': 'y'
              });

              $icon.removeClass(iRem).addClass(iAdd);
            }).toggleClass('active is-expanded');
          $('.js-product-carousel', $me).get(0).slick.setPosition();
          $('.product-grid__item', $me).matchHeight();

          return false;
        });
      }); // end $module
    }
  };
})(jQuery);
